import api from './client';

export const notesApi = {
  getForRecord: (recordId) => api.get('/notes/' + recordId).then(r => r.data),
  create: (data) => api.post('/notes', data).then(r => r.data),
  update: (id, data) => api.put('/notes/' + id, data).then(r => r.data),
  delete: (id) => api.delete('/notes/' + id).then(r => r.data),
};
